function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "location",
  transform: "translate(-774 -1155)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_12",
  "data-name": "Trazado 12",
  d: "M792.592,1164.3a9.3,9.3,0,0,0-18.592,0c0,6.2,9.3,17.043,9.3,17.043S792.592,1170.493,792.592,1164.3Zm-13.169,0a3.873,3.873,0,1,1,3.873,3.873A3.875,3.875,0,0,1,779.423,1164.3Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_6",
  "data-name": "Rect\\xE1ngulo 6",
  width: 12,
  height: 2,
  transform: "translate(776.586 1183.93)"
}));

function SvgLocation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.592,
    height: 30.93,
    viewBox: "0 0 18.592 30.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.dd5b9329.svg";
export { ForwardRef as ReactComponent };